import React, {useContext} from 'react';
import {Query} from 'react-apollo';
import LoadedCategory from './LoadedCategoryContainer';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

import {query} from './categoryQuery';
import {HomeRouteContext} from 'utils/context';
import withQuery from 'utils/withQuery';

const CategoryWithLoading = withQuery(LoadedCategory);
function CategoryContainer(props) {
    const homeRoute = useContext(HomeRouteContext);
    const {categoryId, preview} = props;
    const variables = {categoryId, preview};
    return (
        <Query {...{query, variables}}>
            {(response) => {
                return (
                    <CategoryWithLoading {...{...props, response, homeRoute}} />
                );
            }}
        </Query>
    );
}

export default determineIfMobile(CategoryContainer, 991);
